import { render, staticRenderFns } from "./ResumoFluxoIrregular.vue?vue&type=template&id=1994f9bc"
import script from "./ResumoFluxoIrregular.vue?vue&type=script&lang=js"
export * from "./ResumoFluxoIrregular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports